import {
    DOCUMENT_CREATE_REQUEST,
    DOCUMENT_CREATE_SUCCESS,
    DOCUMENT_CREATE_FAIL,
    DOCUMENT_CREATE_CLEAR,
    DOCUMENTS_LIST_REQUEST,
    DOCUMENTS_LIST_SUCCESS,
    DOCUMENTS_LIST_FAIL,
    GET_DOCUMENT_REQUEST,
    GET_DOCUMENT_SUCCESS,
    GET_DOCUMENT_FAIL,
    DELETE_DOCUMENT_REQUEST,
    DELETE_DOCUMENT_SUCCESS,
    DELETE_DOCUMENT_FAIL
} from '../constants/documentConstant'

export const createDocumentReducer = (state = {}, action) => {
    switch(action.type) {
        case DOCUMENT_CREATE_REQUEST:
            return {loading:true, error:null}
        case DOCUMENT_CREATE_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case DOCUMENT_CREATE_FAIL:
            return {loading:false, error:action.payload}
        case DOCUMENT_CREATE_CLEAR:
            return {message:null, error:null}
        default:
            return state
    }
}

export const listDocumentsReducer = (state = {}, action) => {
    switch(action.type) {
        case DOCUMENTS_LIST_REQUEST:
            return {loading:true, error:null}
        case DOCUMENTS_LIST_SUCCESS:
            return {loading:false, error:null, documents:action.payload, count:action.count, page:action.page}
        case DOCUMENTS_LIST_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}

export const getDocumentReducer = (state = {}, action) => {
    switch(action.type) {
        case GET_DOCUMENT_REQUEST:
            return {loading:true, error:null}
        case GET_DOCUMENT_SUCCESS:
            return {loading:false, error:null, document:action.payload}
        case GET_DOCUMENT_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}

export const deleteDocumentReducer = (state = {}, action) => {
    switch(action.type) {
        case DELETE_DOCUMENT_REQUEST:
            return {loading:true, error:null}
        case DELETE_DOCUMENT_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case DELETE_DOCUMENT_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}
